import link from "./link";

export default { link };
